export default __webpack_public_path__ + "static/media/danny k davis.1d52104a.jpg";